import updateHeaderBasketSummary from '../common/updateHeaderBasketSummary'
import csrfPost from '../common/helpers/csrfPost'
import type { DataRow } from '../components/CutToSizeGroup/types/models'

const submitCuttingToolBar = async (data, emitCrossSellEvent = false) => {
  // Check for any invalid submissions
  const invalidItems = Object.values<DataRow>(data).some(({ valid }) => !valid)
  if (invalidItems) {
    alert('There was a problem adding to your basket. Please check the cutting instructions.')
    return false
  }

  try {
    const json = await csrfPost('/cutting-tool/add-to-basket', {
      cutting_tool: { data }, emit_cross_sell_event: emitCrossSellEvent
    })
    updateHeaderBasketSummary(json.basket)

    if (globalThis.clearCuttingBarInputs) globalThis.clearCuttingBarInputs()

    return true
  } catch {
    alert('There was a problem adding to your basket. Please try again.')
    return false
  }
}

// If there is a cutting tool on the page, submit it
const generateDataAndSubmitCuttingToolBar = async () => {
  const hasTool = document.getElementById('cuttingTool')
  if (hasTool === null) {
    return
  }

  await generateAndSubmitCuttingToolDataFrom('.cuttingTool-table-container')
}

const generateAndSubmitCuttingToolDataFrom = async (selector: string, emitCrossSellEvent = false) => {
  const data = {}
  let count = 0
  const groups = document.querySelectorAll<HTMLElement>(selector)
  groups.forEach((element) => {
    const { product, length, width, quantity, valid, cansubmit } = element.dataset
    if (cansubmit === 'true') {
      data[count] = { product, length, width, quantity, valid: valid === '1' }
      count++
    }
  })
  if (count > 0) await submitCuttingToolBar(data, emitCrossSellEvent)
}

export { generateDataAndSubmitCuttingToolBar, generateAndSubmitCuttingToolDataFrom, submitCuttingToolBar }
